import { render, staticRenderFns } from "./labelIndex.vue?vue&type=template&id=48036cec&scoped=true"
import script from "./labelIndex.vue?vue&type=script&lang=js"
export * from "./labelIndex.vue?vue&type=script&lang=js"
import style0 from "./labelIndex.vue?vue&type=style&index=0&id=48036cec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48036cec",
  null
  
)

export default component.exports